import React, { useEffect, useState } from 'react';
import {
  IScheduleFieldsFragment,
  ScheduleType,
} from '../../../utils/apollo/graphqlSchema';
import * as FormUI from '../../pageForm/FormUI';
import TriggerScheduleModal from '../components/TriggerScheduleModal';
import DeleteScheduleModal from '../components/DeleteScheduleModal';
import { useScheduleModalHandlers } from '../utils';
import useBootstrapDashboardSchedules from './useBootstrapDashboardSchedules';
import Scheduler from '../../../components/Scheduler';
import { ScheduleScreenshotModal } from '../components/ScheduleHistory';
import styled from 'styled-components';
import { useAppSelector } from '../../../redux/hooks';
import { isNotNil } from '../../../utils/types';
import { ContentLoader } from '../../../components/Loaders';
import SearchInput from '../../../components/Form/SearchInput';
import { pluralize } from '../../../utils/formatText';
import { useDebounce } from '../../../utils/hooks';
import { useDashboardScheduleSearchParamsEffect } from '../../../utils/searchParamsDataSharing';
import { useAnalytics } from '../../../utils/analytics/useAnalytics';
import { pageViewed } from '../../../utils/analytics/events/page/events';
import ScheduleDashboardTable from './ScheduleDashboardTable';

const scheduleType = ScheduleType.Dashboard;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export default () => {
  const { track } = useAnalytics();
  useEffect(() => {
    track(
      pageViewed({
        category: 'schedule',
        name: 'dashboard',
        id: null,
      }),
    );
  }, [track]);

  const [searchQuery, setSearchQuery] = useState('');
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  useDashboardScheduleSearchParamsEffect(setSearchQuery);

  const loading = useBootstrapDashboardSchedules({
    searchTerm: debouncedSearchQuery,
  });
  const screenshotSelectedImage = useAppSelector(
    (state) => state.scheduler.screenshotSelectedImage,
  );
  const {
    isDeleteScheduleModalOpen,
    isExecuteScheduleModalOpen,
    isEditScheduleModalOpen,
  } = useScheduleModalHandlers();

  const schedules: IScheduleFieldsFragment[] = useAppSelector(
    (state) => state.dictionary.scheduleDashboard,
  );

  return (
    <>
      <Header>
        <div />
        <SearchInput
          placeholder={`Search ${schedules?.length ?? 0} ${pluralize(
            'Dashboard',
            schedules?.length ?? 0,
          )}`}
          onChange={setSearchQuery}
          value={searchQuery}
        />
      </Header>
      <FormUI.Container>
        {schedules?.length > 0 ? (
          <>
            <ScheduleDashboardTable schedules={schedules} />
            {isExecuteScheduleModalOpen && (
              <TriggerScheduleModal type={scheduleType} />
            )}
            {isDeleteScheduleModalOpen && (
              <DeleteScheduleModal type={scheduleType} />
            )}
            {isEditScheduleModalOpen && (
              <Scheduler jobType={ScheduleType.Dashboard} />
            )}
            {isNotNil(screenshotSelectedImage) && <ScheduleScreenshotModal />}
          </>
        ) : (
          loading && <ContentLoader noBorders={true} />
        )}
      </FormUI.Container>
    </>
  );
};
